<template>
  <div class="list">

    <h2>Saisie conso</h2>
      <!-- provisoire -->
      <el-alert
        title="information"
        type="info"
        description="Le suivi conso n'est pas disponible pour l'instant dans cet outils."
        show-icon>
      </el-alert>
      <!-- CI DESSOUS A decommenter -->
      <!-- <el-alert
        title="information"
        type="info"
        data-v-step="4"
        show-icon>
        Saisissez la quantité restante pour chacun des produits ci-dessous
        à la date du {{ dateSaisie }} (à la fermeture)
      </el-alert> -->
      <Card>
      <el-button type="primary" @click="print"
      data-v-step="btn-print" v-if="list.length > 0">Imprimer</el-button>
    </Card>
      <div id="for-print">
        <div class="content-family-for-print hidden" >
          <table border="1">
            <thead>
              <tr>
                <td>Nom</td>
                <td>Zone avant</td>
                <td>Zone arrière</td>
                <td>Total</td>
                <td>Unité</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(product,index) in list" :key="index" >
                <td>{{ product.name }}</td>
                <td>{{ product.stockJAv !== 0 ? product.stockJAv : '' }}</td>
                <td>{{ product.stockJAr !== 0 ? product.stockJAr : '' }}</td>
                <td>{{ product.stockJ !== 0 ? product.stockJ : '' }}</td>
                <td>{{ product.unit }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div id="list-products">
        <ProductSaisie
        :key="index"
        :product="product"
        @onInput="saveQuantity"
        v-for="(product,index) in list" />
      </div>
      <el-button type="primary" @click="print" v-if="list.length > 0">Imprimer</el-button>

      <div class="no-saisie-text" v-if="list.length === 0">
        Aucune saisie pour le moment.
      </div>
  </div>
</template>

<script>
import services from 'services';
import { Message } from 'element-ui';
import ProductSaisie from '@/components/Product/ProductSaisie.vue';
import Card from '@/components/Card/Card.vue';

export default {
  components: {
    ProductSaisie,
    Card,
  },
  props: {
    list: Array,
  },
  data() {
    return {
      errors: [],
      traiterEvenementDebounce: null,
      dateSaisie: '',
    };
  },
  mounted() {
    this.dateSaisie = services.ProductService.displayDateSaisie();
  },
  methods: {
    displaySuccessMessage() {
      this.$message({
        showClose: true,
        message: 'Enregistrement avec succès.',
        type: 'success',
      });
    },
    displayErrorMessage() {
      this.$message({
        showClose: true,
        message: "Erreur d'enregistrement.",
        type: 'error',
      });
    },
    async saveQuantity(data) {
      Message.closeAll();
      try {
        // console.log('Catch emit OnInput');
        // console.log(data);
        if (data.stockJ === undefined) {
          await Promise.reject();
        }
        // this.$store.dispatch('inventory/setQuantityInventory', { data });
        const resultSetQuantity = await this.$store.dispatch('products/setQuantityInventory', { data });
        const {
          productId, stockJ, name, unit,
        } = data;
        const quantity = `${stockJ} ${unit}`;
        if (resultSetQuantity === null) {
          this.$mixpanel.track('Saisie quantité erronée - Saisie conso', {
            app: 'inventaire',
            productId,
            productName: name,
            quantity,
            userAgent: navigator.userAgent,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
          });
          this.displayErrorMessage();
        } else {
          this.$mixpanel.track('Saisie quantité avec succès - Saisie conso', {
            app: 'inventaire',
            productId,
            productName: name,
            quantity,
            userAgent: navigator.userAgent,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
          });
          this.displaySuccessMessage();
        }
      } catch (error) {
        this.$mixpanel.track('Saisie quantité erronée - Saisie conso', {
          app: 'inventaire',
          product: data,
          userAgent: navigator.userAgent,
          screenHeight: window.screen.height,
          screenWidth: window.screen.width,
        });
        this.displayErrorMessage();
        // console.error(error);
      }
    },
    print() {
      const dateSaisie = new Date();
      this.$mixpanel.track('Impression papier - Saisie conso', {
        app: 'inventaire',
        dateImpression: dateSaisie.toString(),
        userAgent: navigator.userAgent,
        screenHeight: window.screen.height,
        screenWidth: window.screen.width,
      });
      // Pass the element id here
      this.$htmlToPaper('for-print');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

$margin = 25px;

h3
  margin 40px 0 0

ul
  list-style-type none
  padding 0

li
  display inline-block
  margin 0 10px

a
  color #42b983

h2
  margin : $margin;
.el-alert {
    margin: $margin;
    width: 80%;
}

.no-saisie-text
  margin: $margin;

.hidden {
  display: none;
}

@media print
{
  .content-family-for-print span {
    font-weight: bold;
  }
  .content-family-for-print table {
    width: 100%;
    border-collapse: collapse;
  }
}
</style>
